
import React from 'react'
import Employees from '../employee/Employees'
import './main.styles.scss';
import HeaderComponent from '../../header/HeaderComponent'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import SidebarComponent from '../../SideBar/SidebarComponent'
import SideBar from '../../SideBar/SideBar';
import { useState } from 'react';
import Dashboard from '../dashboard/dashboard';
import { connect } from 'react-redux';
import { MainProtectedRoute } from '../../../../router/MainProtectedRoute';

export const MainLayoutComponent = props => {
  const [ Component, setComponent ] = useState(null);
  return (
    <div className="main-layout" >
      <div className="first">
        <SideBar setComponent={setComponent} />
      </div>
      <div className = "main-area" >
        <HeaderComponent />
        {Component ? <Component /> : props.children}
      </div>
      </div>
    )
}

function mapStateToProps(state) {
  return {
    cacNumber: state.userReducer.cacNumber,
    user: state.userReducer.user,
    buttonloader: state.utilityReducer.buttonloader,
    spinner: state.utilityReducer.spinner,
  };
}
const mapDispatchToProps = (dispatch) => ({
  SetLoader() {
    dispatch({type: "LOADING_BUTTON_SPINNER"});
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(MainLayoutComponent)




